<template>
  <q-select
    ref="countrySelect"
    v-model="terms"
    :class="{ required: required }"
    dense
    outlined
    :clearable="$attrs.clearable !== false"
    use-input
    emit-value
    map-options
    options-dense
    hide-selected
    hide-bottom-space
    :fill-input="$attrs['fill-input'] !== false"
    :options="countriesOptions"
    :label="getLabel"
    :error="error"
    :error-message="errorMessage"
    :disable="disable"
    :readonly="readonly"
    autocomplete="remove"
    @filter="search"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CountrySearchField',
  props: {
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectDefault: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: [Object, Boolean],
    },
    onSelectReset: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    terms: '',
    countriesOptions: [],
  }),
  watch: {
    terms: {
      handler(to) {
        if (to) {
          this.$emit('input', to)
          let selectedOption = this.countries.find(x => x.value === to)
          this.$emit('callback', {
            name: selectedOption.label,
            id: selectedOption.value,
          })
        }
        if (this.onSelectReset) {
          this.reset()
        }
      },
    },
    selected: {
      handler(to) {
        this.countriesOptions.push(to)
        this.terms = to.value || null
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      countries: state => state.globalCMP.allCountriesOptions.data.options,
    }),
    getLabel() {
      return this.label || this.$ts('labels.payCycle')
    },
  },
  methods: {
    ...mapActions(['getCommissionWeekSearchAction']),
    async search(terms, update) {
      let filterOptions = [...this.countries]
      if (this.selected) {
        filterOptions = [...filterOptions, ...[this.selected]]
      }
      if (terms !== '') {
        update(() => {
          this.countriesOptions = filterOptions.filter(x => {
            let label = x.label.toLowerCase()
            terms = terms.toLowerCase()
            return label.includes(terms)
          })
        })
      } else {
        update(() => {
          this.countriesOptions = filterOptions
        })
      }
    },
    reset() {
      this.$refs.countrySelect.reset()
      this.terms = ''
    },
  },
}
</script>
